import _ from 'lodash';
import browserHistory from 'history/browser';

const currentPathPanel = state => {
  const _prepPathnames = browserHistory.location.pathname.split('/');
  return _prepPathnames[_prepPathnames.length - 1];
};

export default {
  currentPathPanel,
};
